import { afterNextRender, computed, DestroyRef, Directive, ElementRef, inject, input } from '@angular/core';

/** Fades an element up into place the first time it scrolls into view. */
@Directive({
  selector: '[appReveal]',
  host: { '[style.--reveal-delay]': 'delay()' },
})
export class RevealDirective {
  /** optional stagger, in milliseconds */
  readonly appReveal = input<number | string>('');
  protected readonly delay = computed(() => (this.appReveal() ? `${this.appReveal()}ms` : null));

  constructor() {
    const el = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
    const destroyRef = inject(DestroyRef);

    afterNextRender(() => {
      if (!('IntersectionObserver' in window)) return;
      // the hidden state is only applied once we know we can reveal it again
      el.classList.add('reveal');
      const io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            el.classList.add('is-in');
            io.disconnect();
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
      );
      io.observe(el);
      destroyRef.onDestroy(() => io.disconnect());
    });
  }
}
